import {Controller} from '@hotwired/stimulus';

/**
 * Inscrit dans l'URL l'onglet cliqué (`?tab=<id du bouton>`), sans recharger la page.
 *
 *   <div role="tablist" {{ stimulus_controller('tab-url') }}>
 *     <button id="nav-x-tab" data-bs-toggle="tab" {{ stimulus_action('tab-url', 'remember') }}>…</button>
 *   </div>
 *
 * Le paramètre d'action `tab` remplace l'id quand le serveur attend un autre nom d'onglet :
 * `{{ stimulus_action('tab-url', 'remember', null, {tab: 'comment'}) }}`.
 */
export default class extends Controller {
  remember(event) {
    const tab = event.params.tab ?? event.currentTarget.id;

    window.history.pushState(null, '', `${window.location.pathname}?${new URLSearchParams({tab})}`);
  }
}
